import {styled} from '@mui/material/styles'

// Images
import ForgotPass from '~/assets/images/ForgotPass.png'

const styledName = 'ResetPassword'

export const StyledResetPasswordBackground = styled('div', {name: styledName})({
    "&": {
        backgroundImage: `url(${ForgotPass})`,
        width: "100vw",
        height: "100vh",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      },
})